var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"block-each-student"},[_c('div',{staticClass:"each-student"},[_c('div',{staticClass:"number-student"},[_vm._v(_vm._s(_vm.id))]),_c('div',{staticClass:"name-student"},[_vm._v(_vm._s(_vm.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }